// @flow

import _ from 'lodash';
import moment from 'moment';

import {takeBasename, meses, labelize_mav} from './utils.js';
import {T_DIR, T_CULTI, T_MS, T_MAV, T_PNG, T_OBS, T_PM, T_UNKNOWN} from './codtype.js';
import {LB_PM} from './consts.js';
import type {T_Node, T_Item} from './types.js';

const S = require("underscore.string");



function fecha_ms(mav_filename: string): string {
  const ui = mav_filename.indexOf("_"),
        dd  = mav_filename.slice(ui + 1, ui + 3),
        mm  = mav_filename.slice(ui + 3, ui + 5),
        yy  = mav_filename.slice(ui + 5, ui + 9);
  
  if (mm === '00') {
    return '';
  }
  
  return `${dd}/${meses[parseInt(mm, 10) - 1]}/${yy}`;
};



function fecha_sensor(sensor_fecha: string): string {
  const date = new Date(parseInt(sensor_fecha, 10));
  const dd = date.getDate();
  const mm = date.getMonth();
  const yy = date.getFullYear();
  return `${dd}/${meses[mm]}/${yy}`;
};


function label_tematico(filename: string): string {
  // return takeBasename(filename).split('_').map(w => w === 'Tematico' ? 'Temático' : w).join(' ');
  return takeBasename(filename).replace('Mapa_Tematico_', 'MT_').split('_').join(' ').replace(/-/g, '/');
}



function label_diff(filename: string): string {
  return `M.D. ${takeBasename(filename.slice(5)).split('_').reverse().join(' - ')}`;
}



export default function get_order(xnode: T_Node): T_Item {
  const item: T_Item = {
    Path  : xnode.Path,
    File  : xnode.File,
    Type  : xnode.Type,
    label : xnode.File,
    order : 1000,
    Cod   : T_UNKNOWN,
    Unpub : xnode.Unpub || false,
    Days  : 0,
  };
  
  const es_culti = item.File.match(/^cultivable/),
        old_pm   = item.File.indexOf('ms_0000') === 0,
        es_ms    = item.File.match(/^ms_/) && ! old_pm,
        es_mr    = item.File.match(/^mr_/),
        es_mfs   = item.File.match(/^mfs_/),
        es_mf    = item.File.match(/^mf_/),
        es_mav   = item.File.match(/^mav/),
        es_pm    = item.File.match(/^pm/i) || old_pm;
  
  if (item.Type === 'dir') {
    item.Cod = T_DIR;
  }
  else if (item.Type === 'shp' && es_culti) {
    item.Cod = T_CULTI;
  }
  else if (item.Type === 'shp' && es_pm) {
    item.Cod = T_PM;
  }
  else if (item.Type === 'shp' && (es_ms || es_mr || es_mfs || es_mf)) {
    item.Cod = T_MS;
  }
  else if (item.Type === 'shp' && es_mav) {
    item.Cod = T_MAV;
  }
  else if (item.Type === 'png') {
    item.Cod = T_PNG;
  }
  else if (item.Type === 'obs') {
    item.Cod = T_OBS;
  }
  else {
    item.Cod = T_UNKNOWN;
  }
  
  if (item.label === 'MAPS') {
    item.label = 'Todo';
  }
  
  const lowFile = item.File.toLowerCase();
  
  if (item.Type === "dir") {
    item.order = -1000;
  }
  else if (item.Type === "shp") {
    const es_macro  = lowFile.match(/^macrozona/),
          es_uculti = lowFile.match(/^union_cultivable/),
          es_ums    = item.File.match(/^union_ms_/),
          date_ms   = es_ms || es_mr || es_mfs || es_mf || es_pm ? fecha_ms(item.File) : '';
    
    if      (es_macro)  { item.label = 'Macrozona'                                          ; item.order = -50; }
    else if (es_culti)  { item.label = 'Cultivable'                                         ; item.order = -40; }
    else if (es_uculti) { item.label = 'Cultivable'                                         ; item.order = -50; }
    else if (es_ms)     { item.label = `Muestras de Suelo ${date_ms}`                       ; item.order = -30; }
    else if (es_ums)    { item.label = 'Muestras de Suelo '                                 ; item.order = -49; }
    else if (es_mr)     { item.label = `Muestras de Rendimiento ${date_ms}`                 ; item.order = -25; }
    else if (es_mfs)    { item.label = `Muestras Físicas ${date_ms}`                        ; item.order = -20; }
    else if (es_mf)     { item.label = `Muestras Foliares ${date_ms}`                       ; item.order = -10; }
    else if (es_mav)    { item.label = labelize_mav(item.File)                              ; item.order =  -5; }
    else if (es_pm)     { item.label = lowFile === 'pm.shp' ? LB_PM : `${LB_PM} ${date_ms}` ; item.order =  -5; }
  }
  // else if (item.Type === "multi" && lowFile.match(/cultivable/)) {
  //   item.label = 'Cultivable (unión lógica)' ; item.order = -20;
  // }
  // else if (item.Type === "multi" && lowFile === "ms.multi") {
  //   item.label = 'Muestras de suelo (unión lógica)' ; item.order = -10;
  // }
  else if (item.Type === 'sensor') {
    item.order = 990000 + 10;
    
    const file   = item.File.split('-'),
          titulo = file[0].replace(/_/g, ' ');
    
    item.label = `${titulo} ${fecha_sensor(file[1])}`;
  }
  
  else if (item.Type === 'collect') {
    item.order = 990000 + 20;
    
    item.label = 'Puntos Collect';
  }
  
  else if (item.Type === 'obs') {              // una sola extension, gracias. || item.Type === "nota"
  //   item.order = 990000;
  //   item.label = takeBasename(item.File);
    item.order = 990000;
    
    const title = item.File.split('T')[0].replace(/-/g, '/'),
          fecha = moment(new Date(title)).format('DD/MMM/YYYY');
    
    // let fecha = [title.split('/')[1], '/', title.split('/')[2], '/', title.split('/')[0]].join('');
    
    item.label = `Pto Obs ${fecha.replace(/\./g, '')}`;
  }
  // else if (item.Type === "gpx") {
  //   item.order = 500000;
  // }
  // else if (item.Type === "tif") {
  //   if (lowFile.match(/^macrozona/)) {
  //     item.hide = true;
  //   }
  //   item.order = 100000;
  // }
  // else if (item.Type === "doc") {
  //   item.order = 200000 - 1;
  // }
  // else if (item.Type === "zip") {
  //   item.order = 200000;
  // }
  // else if (item.Type === "png" && item.File.match(/^Reclass/)) {
  //   item.label = labelize_mav(item.File);
  //   item.order = 500;
  // }
  else if (item.Type === "png" || item.Type === "multi") {
    // item.es_escala = false;
    // 
    // if (_.has(x, "Path") && item.Path.indexOf("/srv/www/htdocs/img/escalas_nuevas/") === 0) {
    //   item.es_escala = true;
    //   return x;
    // }
    
    if (lowFile.match(/^macrozona_/)) {
      item.label = takeBasename(item.File).slice(10);

      if (item.label === "pH")  { item.order = 60; }
      if (item.label === "M.O") { item.order = 61; }
      if (item.label === "Al")  { item.order = 62; }
      if (item.label === "P")   { item.order = 63; }
      if (item.label === "K")   { item.order = 64; }
      if (item.label === "Ca")  { item.order = 65; }
      if (item.label === "Mg")  { item.order = 66; }
      if (item.label === "Na")  { item.order = 67; }
      if (item.label === "S")   { item.order = 68; }
      if (item.label === "B")   { item.order = 69; }
      if (item.label === "Zn")  { item.order = 70; }
      if (item.label === "Cu")  { item.order = 71; }
      if (item.label === "Fe")  { item.order = 72; }
      if (item.label === "Mn")  { item.order = 73; }
      else                      { item.order = 80; }
      
      return item;
    }
    
    // NOTE: ESTAS DE AQUÍ SON ABREVIACIONES. EL NOMBRE COMPLETO SE PUEDE OBTENER EN Book.get_elem_fullname(),
    // QUE TOMA ESTOS MISMOS LABELS Y LOS TRANSFORMA EN UN STRING COMPLETO.
    
    if      (lowFile.match(/^mapa_tematico_/))             { item.label = label_tematico(item.File); item.order = 500; }
    else if (lowFile.match(/^diff/))                       { item.label = label_diff    (item.File); item.order = 600; }
    else if (item.File.match(/^pH[._-]?CaCl/))             { item.label = 'pH_CaCl';              item.order = 1;   }
    else if (item.File.match(/^pH/))                       { item.label = 'pH';                   item.order = 0;   }
    else if (item.File.match(/^M[._-]O/))                  { item.label = 'M.O';                  item.order = 10;  }
    else if (item.File.match(/^C[._-]E/))                  { item.label = 'CE';                   item.order = 20;  }
    else if (item.File.match(/^CaCO3/))                    { item.label = 'CaCO3';                item.order = 30;  }
    else if (item.File.match(/^CACO3/))                    { item.label = 'CaCO3';                item.order = 31;  }
    else if (item.File.match(/^CAK[._-]/))                 { item.label = 'Ca / K';               item.order = 32;  }
    else if (item.File.match(/^CAMG[._-]/))                { item.label = 'Ca / Mg';              item.order = 33;  }
    else if (item.File.match(/^CAMGK[._-]/))               { item.label = '(Ca + Mg) / K';        item.order = 34;  }

    else if (item.File.match(/^Al[._-]cs2/))               { item.label = 'Al';                   item.order = 45;  }
    else if (item.File.match(/^Al[._-]int/))               { item.label = 'Al_int';               item.order = 42;  }
    else if (item.File.match(/^Al[._-]Extrac/))            { item.label = 'Al_ext';               item.order = 41;  }
    else if (item.File.match(/^Al[._-]ext/))               { item.label = 'Al_ext';               item.order = 43;  }
    else if (item.File.match(/^Al[._-]extrac[._-]iansa1/)) { item.label = 'Al_ext';               item.order = 2;   }
    else if (item.File.match(/^Al[._-]extrac[._-]iansa/))  { item.label = 'Al_ext';               item.order = 44;  }
    else if (item.File.match(/^Al[._-]cl/))                { item.label = 'Al';                   item.order = 45;  }
    else if (item.File.match(/^Al/))                       { item.label = 'Al';                   item.order = 40;  }
    else if (lowFile.match(/^no3nh4/))                     { item.label = 'N';                    item.order = 57;  }
    else if (item.File.match(/^N[._-]fbd/))                { item.label = 'N';                    item.order = 57;  }
    else if (item.File.match(/^N[._-]iansa/))              { item.label = 'N';                    item.order = 56;  }
    else if (item.File.match(/^N[._-]iansa1/))             { item.label = 'N';                    item.order = 3;   }
    else if (item.File.match(/^N[._-]fcaf/))               { item.label = 'N';                    item.order = 55;  }
    else if (item.File.match(/^N[._-]to/))                 { item.label = 'N';                    item.order = 61;  }
    else if (item.File.match(/^N[._-]Total/))              { item.label = 'N_total';              item.order = 50;  }
    else if (item.File.match(/^N[._-]Min/))                { item.label = 'N_min';                item.order = 51;  }
    else if (item.File.match(/^N[._-]Mineral/))            { item.label = 'N_min';                item.order = 52;  }
    else if (item.File.match(/^N[._-]Mineral[._-]cl/))     { item.label = 'N_min';                item.order = 54;  }
    else if (lowFile.match(/^nitrogen/))                   { item.label = 'N_min';                item.order = 54;  }
    else if (item.File.match(/^N[._-]Disp/))               { item.label = 'N_disp';               item.order = 53;  }
    else if (item.File.match(/^N[._-]fvpp/))               { item.label = 'N';                    item.order = 58;  }
    else if (item.File.match(/^N[._-]fpa17c/))             { item.label = 'N';                    item.order = 59;  }
    else if (item.File.match(/^N[._-]fpj9c/))              { item.label = 'N';                    item.order = 60;  }
    else if (item.File.match(/^N[._-]fp17d/))              { item.label = 'N';                    item.order = 62;  }
    else if (item.File.match(/^N[._-]ftpp/))               { item.label = 'N';                    item.order = 63;  }
    else if (item.File.match(/^N[._-]d/))                  { item.label = 'N';                    item.order = 64;  }
    else if (item.File.match(/^N[._-]vid/))                { item.label = 'N';                    item.order = 65;  }
    else if (item.File.match(/^N[._-]flndpp/))             { item.label = 'N';                    item.order = 66;  }
    else if (item.File.match(/^N[._-]/))                   { item.label = 'N';                    item.order = 67;  }
    else if (item.File.match(/^NH4/))                      { item.label = 'NH4';                  item.order = 69;  }
    else if (item.File.match(/^NO3/))                      { item.label = 'NO3';                  item.order = 70;  }
    
    else if (lowFile.match(/^polsen/))                     { item.label = 'P_Olsen';              item.order = 82;  }
    
    else if (item.File.match(/^P[._-]H2O/))                { item.label = 'P_H20';                item.order = 81;  }
    else if (item.File.match(/^P[._-]/))                   { item.label = 'P';                    item.order = 80;  }
    else if (item.File.match(/^K[._-]int/))                { item.label = 'K_int';                item.order = 100; }
    else if (item.File.match(/^K[._-]cl/))                 { item.label = 'K';                    item.order = 101; }
    else if (item.File.match(/^K[._-]/))                   { item.label = 'K';                    item.order = 90;  }

    else if (item.File.match(/^photosense/))               { item.label = 'Photosense';           item.order = 90;  }

    else if (item.File.match(/^K[._-]fp/))                 { item.label = 'K';                    item.order = 91;  }
    else if (item.File.match(/^Ca[._-]cl/))                { item.label = 'Ca';                   item.order = 111; }
    else if (item.File.match(/^Ca[._-]disponible/))        { item.label = 'Ca_dis';               item.order = 112; }
    else if (item.File.match(/^Ca[._-]/))                  { item.label = 'Ca';                   item.order = 110; }
    else if (item.File.match(/^Mg[._-]cl/))                { item.label = 'Mg';                   item.order = 121; }
    else if (item.File.match(/^Mg[._-]/))                  { item.label = 'Mg';                   item.order = 120; }
    else if (item.File.match(/^MGK/))                      { item.label = 'Mg / K';               item.order = 122; }
    else if (item.File.match(/^Na[._-]cl/))                { item.label = 'Na';                   item.order = 131; }
    else if (item.File.match(/^Na[._-]/))                  { item.label = 'Na';                   item.order = 130; }
    else if (item.File.match(/^NA[._-]/))                  { item.label = 'Na';                   item.order = 132; }
    else if (item.File.match(/^S[._-]cl/))                 { item.label = 'S';                    item.order = 141; }
    else if (item.File.match(/^S[._-]/))                   { item.label = 'S';                    item.order = 140; }
    else if (item.File.match(/^B[._-]/))                   { item.label = 'B';                    item.order = 150; }
    else if (item.File.match(/^Zn[._-]/))                  { item.label = 'Zn';                   item.order = 160; }
    else if (item.File.match(/^Cu[._-]/))                  { item.label = 'Cu';                   item.order = 170; }
    else if (item.File.match(/^Mo[._-]/))                  { item.label = 'Mo';                   item.order = 180; }
    else if (item.File.match(/^Fe[._-]/))                  { item.label = 'Fe';                   item.order = 190; }
    else if (item.File.match(/^Mn[._-]/))                  { item.label = 'Mn';                   item.order = 200; }
    else if (item.File.match(/^C[._-]Org/))                { item.label = 'C_Org';                item.order = 210; }
    else if (item.File.match(/^Sat[._-]Al/))               { item.label = 'Sat_Al';               item.order = 220; }
    else if (item.File.match(/^sumabases/))                { item.label = 'sumabases';            item.order = 230; }
    else if (item.File.match(/^CICE/))                     { item.label = 'CICE';                 item.order = 240; }
    else if (item.File.match(/^CIC[._-]/))                 { item.label = 'CIC';                  item.order = 241; }
    else if (lowFile.match(/^ctextural/))                  { item.label = 'Clases Texturales';    item.order = 405; }
    else if (lowFile.match(/^dap[._-]10/))                 { item.label = 'Densidad Aparente a 10 cm';  item.order = 257; }
    else if (lowFile.match(/^dap[._-]20/))                 { item.label = 'Densidad Aparente a 20 cm';  item.order = 258; }
    else if (lowFile.match(/^dap[._-]30/))                 { item.label = 'Densidad Aparente a 30 cm';  item.order = 259; }
    else if (lowFile.match(/^dap/))                        { item.label = 'Densidad Aparente';          item.order = 260; }
    else if (lowFile.match(/^molibdeno/))                  { item.label = 'Mo';                   item.order = 260; }
    else if (lowFile.match(/^rhumedad[._-]20/))            { item.label = 'retHumedad_20';        item.order = 270; }
    else if (lowFile.match(/^rhumedad[._-]20cm/))          { item.label = 'retHumedad_20';        item.order = 271; }
    else if (lowFile.match(/^rhumedad[._-]30/))            { item.label = 'retHumedad_30';        item.order = 280; }
    else if (lowFile.match(/^rhumedad[._-]30cm/))          { item.label = 'retHumedad_30';        item.order = 281; }
    else if (lowFile.match(/^rhumedad[._-]40/))            { item.label = 'retHumedad_40';        item.order = 290; }
    else if (lowFile.match(/^rhumedad[._-]40cm/))          { item.label = 'retHumedad_40';        item.order = 291; }
    else if (lowFile.match(/^rhumedad[._-]50cm/))          { item.label = 'retHumedad_50';        item.order = 292; }
    else if (lowFile.match(/^rhumedad[._-]60cm/))          { item.label = 'retHumedad_60';        item.order = 293; }
    else if (lowFile.match(/^biomasa/))                    { item.label = 'Biomasa';              item.order = 300; }
    else if (lowFile.match(/^biomass/))                    { item.label = 'Biomass';              item.order = 300; }
    else if (item.File.match(/^Cl[._-]/))                  { item.label = 'Cl';                   item.order = 310; }
    else if (item.File.match(/^CL[._-]/))                  { item.label = 'Cl';                   item.order = 311; }
    else if (item.File.match(/^HCO3[._-]/))                { item.label = 'HCO3';                 item.order = 320; }
    else if (item.File.match(/^PO4[._-]ppm[._-]/))         { item.label = 'PO4-ppm';              item.order = 330; }
    else if (item.File.match(/^PO4[._-]/))                 { item.label = 'PO4';                  item.order = 340; }
    else if (item.File.match(/^Si[._-]/))                  { item.label = 'Si';                   item.order = 341; }
    else if (item.File.match(/^SO4[._-]/))                 { item.label = 'SO4';                  item.order = 350; }
    else if (lowFile.match(/^rhumedad[._-]1/))             { item.label = 'retHumedad';           item.order = 360; }
    else if (item.File.match(/^mav[._-]P/))                { item.label = 'mav P';                item.order = 370; }
    else if (item.File.match(/^mav[._-]S/))                { item.label = 'mav S';                item.order = 371; }
    else if (item.File.match(/^mav[._-]K/))                { item.label = 'mav K';                item.order = 372; }
    else if (item.File.match(/^mav[._-]Ca/))               { item.label = 'mav Ca';               item.order = 374; }
    else if (item.File.match(/^mav[._-]Mg/))               { item.label = 'mav Mg';               item.order = 375; }
    else if (item.File.match(/^mav[._-]Cal/))              { item.label = 'mav Cal';              item.order = 376; }
    else if (item.File.match(/^mav[._-]NO3/))              { item.label = 'mav NO3';              item.order = 377; }
    else if (item.File.match(/^mav[._-]N/))                { item.label = 'mav N';                item.order = 373; }
    else if (item.File.match(/^mav[._-]pH/))               { item.label = 'mav pH';               item.order = 374; }
    else if (item.File.match(/^Ac[._-]Ext/))               { item.label = 'Ac_Ext';               item.order = 380; }
    else if (item.File.match(/^Caliza[._-]act/))           { item.label = 'Caliza-Act';           item.order = 390; }
    else if (item.File.match(/^Ac[._-]Ex[._-]arroz/))      { item.label = 'Ac-Ext-arroz';         item.order = 391; }
    else if (item.File.match(/^P[._-]f20xx/))              { item.label = 'P';                    item.order = 392; }
    else if (item.File.match(/^rdto[._-]/))                { item.label = 'Rendimiento';          item.order = 393; }
    else if (lowFile.match(/^rhumedad[_-]b/))              { item.label = 'Retención de humedad'; item.order = 394; }
    else if (lowFile.match(/^upn/))                        { item.label = 'Upn';                  item.order = 401; }
    else if (lowFile.match(/^fertimap/))                   { item.label = 'Fertimap';             item.order = 400; }
    else if (lowFile.match(/^mpp/))                        { item.label = 'Mpp';                  item.order = 402; }
    else if (lowFile.match(/^termal/))                     { item.label = 'Termal';               item.order = 403; }
    else if (lowFile.match(/^fotoactiva/))                 { item.label = 'Foto Activa';          item.order = 404; }
    
    else if (lowFile.match(/^acidez/))                     { item.label = 'Acidez';                item.order = 403; }
    else if (lowFile.match(/^brix/))                       { item.label = 'Brix';                  item.order = 404; }
    else if (lowFile.match(/^calibre/))                    { item.label = 'Calibre';               item.order = 405; }
    else if (lowFile.match(/^centrosfrutales/))            { item.label = 'Centros frutales';      item.order = 406; }
    else if (lowFile.match(/^color/))                      { item.label = 'Color';                 item.order = 407; }
    else if (lowFile.match(/^firmeza/))                    { item.label = 'Firmeza';               item.order = 408; }
    
    else if (lowFile.match(/^arena/))                      { item.label = 'Arena';                 item.order = 501; }
    else if (lowFile.match(/^limo/))                       { item.label = 'Limo';                  item.order = 502; }
    else if (lowFile.match(/^arcilla/))                    { item.label = 'Arcilla';               item.order = 503; }
    else if (lowFile.match(/^porosidad/))                  { item.label = 'Porosidad';             item.order = 504; }
    else if (lowFile.match(/^d[_-]real/))                  { item.label = 'Densidad real';         item.order = 505; }
    else if (lowFile.match(/^vel[_-]inf/))                 { item.label = 'Vel. infiltración';     item.order = 506; }
    
    else if (lowFile.match(/^carbt/))                      { item.label = 'Carbonatos totales';    item.order = 400; }

    else if (item.File.match(/^PSI[._-]/))                 { item.label = 'PSI';                   item.order = 510; }
    else if (item.File.match(/^RAS[._-]/))                 { item.label = 'RAS';                   item.order = 520; }
    
    else if (lowFile.match(/^prof-eu/))                    { item.label = 'Profundidad enraizable única';  item.order = 404; }
    else if (lowFile.match(/^prof-ef/))                    { item.label = 'Profundidad efectiva';          item.order = 405; }
    else if (lowFile.match(/^escalapalma/))                { item.label = 'Palma en Árbol';                item.order = 406; }
    else if (lowFile.match(/^almacenamientoagua/))         { item.label = 'Almacenamiento de agua';        item.order = 406; }
    else if (lowFile.match(/^gcompact30cm/))               { item.label = 'Grado Compactación 30 cm';      item.order = 407; }
    
    else if (lowFile.match(/^densidadreal/))               { item.label = 'Densidad Real';                 item.order = 408; }
    else if (lowFile.match(/^aguaaprovechable/))           { item.label = 'Agua Aprovechable';             item.order = 409; }
    else if (lowFile.match(/^clasestexturales/))           { item.label = 'Clases Texturales';             item.order = 410; }
    
    else if (lowFile.match(/^premonitor/))              {
      item.label = _(item.File).words(/[-_]/).slice(0,2).join("-").replace("cana", "caña");
      item.order = 400;
      
      if (item.label === "premonitor.png")
        item.label = "Premonitor";
    }
    else {
      item.label = S.titleize(takeBasename(item.File));
      item.order = 600;
    }
  }
  
  if (item.label.toLowerCase().indexOf('-zz') !== -1) {
    item.label = item.label.replace(/-zz.*/i, '');
  }
  
  return item;
}




// WEBPACK FOOTER //
// ./src/orden.js